export enum LookupState {
  INIT = 0,
  LOADING = 1,
  RESULT = 2,
  ERROR = 3,
}
